<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col-sm-12">
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Onboarding Information</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <div class="d-flex justify-content-between">
                    <h4 class="card-title mb-0">Onboarding Information</h4>
                    <div class="col-auto float-right ml-auto">
                      <a
                        class="btn add-btn"
                        @click="openImportDialog"
                        v-if="applications.length > 0"
                        ><i class="fa fa-plus"></i> Bulk Migration</a
                      >
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <ul class="nav nav-tabs nav-tabs-solid nav-tabs-rounded">
                    <li class="nav-item">
                      <a
                        class="nav-link active"
                        href="#solid-rounded-justified-tab1"
                        data-toggle="tab"
                        >Accepted Applicants</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="#solid-rounded-justified-tab2"
                        data-toggle="tab"
                        >New Hire</a
                      >
                    </li>
                  </ul>
                  <div class="tab-content">
                    <div
                      class="tab-pane show active"
                      id="solid-rounded-justified-tab1"
                    >
                      <div class="table-responsive">
                        <v-data-table
                          :headers="headers"
                          :items="applications"
                          sort-by=""
                          class="elevation-1"
                        >
                          <template v-slot:[`item.profile`]="{ item }">
                            <router-link :to="`/applications/${item.id}`">
                              <span>{{
                                item.applicant.firstName +
                                  " " +
                                  item.applicant.lastName
                              }}</span></router-link
                            >
                          </template>
                          <template v-slot:[`item.vacant`]="{ item }">
                            <router-link
                              :to="`/vacancies/vid${item.vacancy.id}`"
                            >
                              <span>{{
                                item.vacancy.jobProfile.title
                              }}</span></router-link
                            >
                          </template>
                          <template v-slot:[`item.start`]="{ item }">
                            {{
                              new Date(
                                item.applicationNegotiation.expectedResumptionDate
                              ).toLocaleDateString()
                            }}
                          </template>
                          <template v-slot:[`item.expected`]="{ item }">
                            ₦{{
                              item.applicationNegotiation.negotiatedSalary
                                .toString()
                                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                            }}
                          </template>
                          <template v-slot:[`item.created`]="{ item }">
                            {{
                              item.createdAt
                                ? new Date(item.createdAt).toLocaleDateString()
                                : ""
                            }}
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <a
                              class="btn btn-primary"
                              aria-expanded="false"
                              @click="setApp(item)"
                            >
                              Migrate
                            </a>
                          </template>
                        </v-data-table>
                      </div>
                    </div>
                    <div class="tab-pane" id="solid-rounded-justified-tab2">
                      <div class="table-responsive">
                        <v-data-table
                          :headers="headers2"
                          :items="hires"
                          sort-by=""
                          class="elevation-1"
                        >
                          <template v-slot:[`item.profile`]="{ item }">
                            <router-link
                              :to="{
                                name: 'employeedetail',
                                params: { id: item.id }
                              }"
                            >
                              <span>{{
                                item.firstName + " " + item.lastName
                              }}</span></router-link
                            >
                          </template>
                          <template v-slot:[`item.expected`]="{ item }">
                            {{ company.abbrv + "-" + item.id }}
                          </template>
                          <template v-slot:[`item.created`]="{ item }">
                            {{
                              item.createdAt
                                ? new Date(item.createdAt).toLocaleDateString()
                                : ""
                            }}
                          </template>
                          <template v-slot:[`item.actions`]="{ item }">
                            <router-link
                              :to="{
                                name: 'onboarding-edit',
                                params: { id: item.id }
                              }"
                            >
                              Onboard
                            </router-link>
                            |
                            <a @click="grantEmployee(item.id)">
                              Grant Access
                            </a>
                          </template>
                        </v-data-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <!-- Applicant Details Modal -->

          <v-dialog v-model="dialog" max-width="725px">
            <div class="modal-content mt-5">
              <div class="modal-header">
                <h5 class="modal-title">Onboarding Process</h5>
                <button type="button" class="close" @click="closeDialog">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <form>
                  <div id="details" v-if="dialogView == 0">
                    <div class="form-group">
                      <label
                        >Firstname <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        readonly
                        :value="app.applicant.firstName"
                      />
                    </div>
                    <div class="form-group">
                      <label>LastName <span class="text-danger">*</span></label>
                      <input
                        class="form-control"
                        readonly
                        :value="app.applicant.lastName"
                      />
                    </div>
                    <div class="form-group">
                      <label>Gender <span class="text-danger">*</span></label>
                      <input
                        class="form-control"
                        readonly
                        :value="app.applicant.gender"
                      />
                    </div>
                    <div class="form-group">
                      <label>Phone <span class="text-danger">*</span></label>
                      <input
                        class="form-control"
                        readonly
                        :value="app.applicant.phone1"
                      />
                    </div>
                    <div class="form-group">
                      <label>Address <span class="text-danger">*</span></label>
                      <input
                        class="form-control"
                        readonly
                        :value="app.applicant.address"
                      />
                    </div>
                    <div class="form-group">
                      <label
                        >Designation <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        readonly
                        :value="app.vacancy.designation.name"
                      />
                    </div>
                    <div class="submit-section">
                      <a class="btn btn-primary submit-btn" @click="next"
                        >Next</a
                      >
                    </div>
                  </div>
                  <div id="official" v-if="dialogView == 1">
                    <h3>Add official email address</h3>
                    <span
                      >Create a new official email for the new employee</span
                    >
                    <div class="form-group">
                      <label
                        >Email Address <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        type="email"
                        v-model="email"
                      />
                    </div>
                    <div class="submit-section">
                      <a class="btn btn-primary submit-btn" @click="next"
                        >Next</a
                      >
                    </div>
                  </div>
                  <div id="official" v-if="dialogView == 2">
                    <h3>Add official Business Unit and Employee Code</h3>
                    <span
                      >Create a new official employee code for the new
                      employee</span
                    >
                    <div class="form-group">
                      <label
                        >Employee Code <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        v-model="employeeCode"
                      />
                    </div>
                    <div class="form-group">
                      <label
                        >Business Unit <span class="text-danger">*</span></label
                      >
                      <select class="form-control" v-model="companyUnitId">
                        <option disabled>Select Business Unit</option>
                        <option
                          v-for="item in units"
                          :key="item.id"
                          :value="parseInt(item.id)"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                    <div class="submit-section">
                      <a class="btn btn-primary submit-btn" @click="onSubmit"
                        >Submit</a
                      >
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </v-dialog>
          <!-- Delete Employee Modal -->
          <v-dialog v-model="dialogImport" max-width="725px">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Bulk Migration</h5>
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="closeImport"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-header">
                  <h3>Migrate Applicants to Employee</h3>
                  <p>
                    Download an excel template by clicking on the below button
                  </p>
                  <br />
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <p>
                      Note: please do not change the layout of the cells in the
                      excel, you are expected to add the new work email address
                      of each employee <br />
                    </p>
                  </div>
                  <div class="col-12">
                    <a
                      @click="downloadTemplate"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                    >
                      Download Template</a
                    >
                  </div>
                </div>
                <hr />
                <hr />
                <div class="row">
                  <div class="col-sm-9">
                    <div class="form-group">
                      <label>Upload File</label>
                      <div class="custom-file">
                        <input
                          type="file"
                          name="file"
                          class="form-control"
                          id="cv_upload"
                          @change="onFilePicked"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <a
                      @click="importEmployee"
                      v-if="file"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                    >
                      Import</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </v-dialog>
          <!-- /Delete Employee Modal -->
          <!-- /Query Details Modal -->
        </div>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { jobService } from "@/services/jobService";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";
import { employeeService } from "@/services/employeeService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      dialog: false,
      dialogView: 0,
      dialogImport: false,
      headers: [
        {
          text: "Name",
          align: "start",
          value: "profile"
        },
        { text: "Designation", value: "vacancy.designation.name" },
        { text: "Start Date", value: "start" },
        { text: "Negotiated Salary", value: "expected" },
        { text: "Action", value: "actions", sortable: false }
      ],
      headers2: [
        {
          text: "Name",
          align: "start",
          value: "profile"
        },
        { text: "Employee ID", value: "expected" },
        { text: "Email", value: "email" },
        { text: "Mobile", value: "phone" },
        { text: "Join Date", value: "created" },
        { text: "Gender", value: "gender" },
        { text: "Action", value: "actions", sortable: false }
      ],
      email: "",
      employeeCode: "",
      companyUnitId: 0,
      welcomeGuideTemplate: "",
      applications: [],
      hires: [],
      units: [],
      app: {
        applicant: {},
        vacancy: {
          designation: {}
        }
      },
      error: "",
      message: "",
      file: null,
      fileName: null,
      company: authenticationService.currentOfficeValue
    };
  },
  mounted() {
    this.getApplications();
    this.GetUnits();
    this.getHires();
    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.getApplications();
      this.getHires();
    },
    GetUnits() {
      organizationService.getCompanyUnits(this.company.id).then(
        model => {
          this.units = model;

          var unitStrings = "";
          model.forEach(t => {
            unitStrings += t.id + " - " + t.name + ", ";
          });
          this.unitStrings = unitStrings;
        },
        error => {
          this.error = error;
        }
      );
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      // console.log(this.fileName)
      this.file = files[0];
    },
    openImportDialog() {
      this.dialogImport = true;
    },
    closeImport() {
      this.dialogImport = false;
    },
    importEmployee() {
      employeeService.importOnboarding(this.company.id, this.file).then(
        response => {
          this.dialogImport = false;
          this.getApplications();
          this.getHires();
        },
        error => {
          this.error = error;
        }
      );
    },
    downloadTemplate() {
      employeeService
        .downloadOnboardingTemplate(this.company.id)
        .then(response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        });
    },
    setApp(item) {
      this.app = item;
      organizationService.getAccountSetting(this.company.id).then(i => {
        this.welcomeGuideTemplate = i.welcomeGuideTemplate;

        this.dialog = true;
      });
    },
    next() {
      this.dialogView += 1;
    },
    onSubmit() {
      var m = {
        applicationID: this.app.id,
        employee: {
          rankId: this.app.vacancy.jobProfile.rankId,
          companyId: this.company.id,
          firstName: this.app.applicant.firstName,
          lastName: this.app.applicant.lastName,
          email: this.email,
          phone: this.app.applicant.phone1,
          designationId: this.app.vacancy.designationId,
          companyUnitId: this.companyUnitId,
          employeeCode: this.employeeCode
        },
        onboarding: {
          welcomeGiude: this.welcomeGuideTemplate
        }
      };

      employeeService.onboard(m).then(
        p => {
          this.message =
            "New employee created!, employee code is " +
            this.company.abbrv +
            "-" +
            p;
        },
        e => {
          this.error = e;
        }
      );
    },

    getApplications() {
      jobService.getAcceptedApplications(this.company.id).then(p => {
        this.applications = p;
      });
    },
    getHires() {
      employeeService.getHires(this.company.id).then(p => {
        this.hires = p;
      });
    },
    grantEmployee(id) {
      employeeService.grantEmployee(id).then(p => {
        this.getHires();
      });
    }
  },
  name: "applications"
};
</script>



// WEBPACK FOOTER //
// src/components/employees/Onboarding.vue